import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort, MatSortable, Sort } from '@angular/material/sort';
import { Message } from '../model/message'
import { List } from 'immutable';
import { Observable, of, defer, concat, Subscription } from 'rxjs';
import { NewMessageDialogComponent } from './new-message-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.css']
})

export class MessageDialogComponent implements OnInit, OnDestroy {

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public messages: List<Message>;
  private expandedId;
  private sortColumn: string = "updatedAt";
  private sortOrder: string = "desc";

  options: BKSMessageOptions = new BKSMessageOptions();

  readonly cookieName = 'BKSMessageOptions';

  private messageSubscription: Subscription;
  newMessageModalRef: MatDialogRef<NewMessageDialogComponent>;

  constructor(
    private readonly messageService: MessageService,
    private readonly cookieService: CookieService,
    private readonly dialog: MatDialog,
    private readonly toastrService: ToastrService) { }

  ngOnInit() {

    var data = this.cookieService.get(this.cookieName);
    if (data) {
      this.options = JSON.parse(data);
    }
    else {
      this.options = new BKSMessageOptions();
    }

    this.fromMatSort(this.sort).subscribe(sort => {

      if (sort.active) {
        this.sortOrder = sort.direction;
        this.sortColumn = sort.active;
        this.handleSort();
      }

    });

    this.messageSubscription = this.messageService.Messages.subscribe(result => {
      console.log(result);
      this.messages = result;

      this.handleSort();
    }, error => console.error(error));


    this.sort.sort(<MatSortable>{ id: this.sortColumn, start: this.sortOrder });
  }

  ngOnDestroy() {

    this.cookieService.set(this.cookieName, JSON.stringify(this.options));

    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
  }

  changeValue() {
    this.cookieService.set(this.cookieName, JSON.stringify(this.options));
  }

  /** Creates an Observable stream of Sort objects from a MatSort component */
  fromMatSort(sort: MatSort): Observable<Sort> {
    return concat(
      defer(() => of({
        active: sort.active,
        direction: sort.direction
      })),
      sort.sortChange.asObservable()
    );
  }

  handleSort() {

    var rows: List<Message>;
    if (this.messages) {
      if (this.sortColumn == 'name') {
        if (!this.options.sent) {
          rows = this.messages.sortBy(u => u.recipientName).toList();
        }
        else {
          rows = this.messages.sortBy(u => u.senderName).toList();
        }
      } else if (this.sortColumn == "title") {
        rows = this.messages.sortBy(u => u.title).toList();
      } else if (this.sortColumn == "updatedAt") {
        rows = this.messages.sortBy(u => u.updatedAt).toList();
      }

      if (this.sortOrder == "desc") {
        this.messages = rows.reverse().toList();
      }
      else {
        this.messages = rows;
      }
    }
  }

  newMessage() {
    this.newMessageModalRef = this.dialog.open(NewMessageDialogComponent, { width: '600px', disableClose: false, closeOnNavigation: false });
    this.newMessageModalRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  setReadFlag(message: Message) {
    if (!message.isRead) {
      message.isRead = true;
      //Send a minimal object with isRead
      this.messageService.updateMessage(message).then(result => {
        console.log("IsRead set");
        message.isRead = true;
      }, (error) => {
        this.toastrService.error("Fel vid läsflaggande");
        console.log("Error on IsRead:", error);
      });
    }
    this.expandedId = message.id;
  }

  closed() {
    this.expandedId = null;
  }

}

class BKSMessageOptions {
  sent: boolean = false;
  onlyUnread: boolean = false;
}
